import { render } from "./HomeBannerRewards.vue?vue&type=template&id=754be894&scoped=true"
import script from "./HomeBannerRewards.vue?vue&type=script&lang=js"
export * from "./HomeBannerRewards.vue?vue&type=script&lang=js"

import "./HomeBannerRewards.vue?vue&type=style&index=0&id=754be894&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-754be894"]])

export default __exports__